import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { LocationOn } from '@mui/icons-material';
import { MyLocation, branchLabel } from '../hooks/useMyLocations';
import { colors } from '../theme/theme';

interface Props {
  location?: MyLocation | null;
  /** Rendered nothing when false — the caller decides, not this component. */
  show?: boolean;
  size?: 'small' | 'medium';
}

/**
 * WHICH BRANCH THIS ROW BELONGS TO.
 *
 * Shown only while the list is aggregating more than one location. On a
 * single-location view every row would carry the same chip, which is noise
 * that trains people to stop reading it — and then it is not there when it
 * matters.
 *
 * The tooltip carries `studioName` because `branchName` alone ("Koramangala")
 * is ambiguous to someone who holds two brands.
 *
 * THE one location bubble: every page that names a row's location uses this,
 * so it looks the same everywhere (pink, pin icon, branch name).
 */
const BranchChip: React.FC<Props> = ({ location, show = true, size = 'small' }) => {
  if (!show || !location) return null;
  const label = branchLabel(location);
  if (!label) return null;

  return (
    <Tooltip title={location.studioName || label} arrow>
      <Chip
        size={size}
        icon={<LocationOn sx={{ fontSize: 14 }} />}
        label={label}
        sx={{
          height: 22,
          fontSize: '0.7rem',
          fontWeight: 600,
          bgcolor: `${colors.primary}14`,
          color: colors.primary,
          '& .MuiChip-icon': { ml: 0.5, mr: -0.25, color: colors.primary },
        }}
      />
    </Tooltip>
  );
};

export default BranchChip;
